import React, { ReactNode, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Loader from '../../components/common/loader';

interface PreviewAuthLoaderProps {
  children: ReactNode;
}

/**
 * Lightweight auth gate for preview routes accessed without a token.
 * Calls /me to check authentication, redirects to login if needed.
 * Much simpler than the full AuthCoordinator — no RESO, no metadata.
 */
const PreviewAuthLoader: React.FC<PreviewAuthLoaderProps> = ({ children }) => {
  const { checkAuthentication, isAuthenticated, isLoading } = useAuth();
  const hasChecked = useRef(false);

  useEffect(() => {
    if (!hasChecked.current) {
      hasChecked.current = true;
      checkAuthentication();
    }
  }, [checkAuthentication]);

  if (isLoading || !isAuthenticated) {
    return (
      <Loader
        text={'Verifying credentials...'}
        mode={'determinate'}
        showHeaderFooter={false}
        speed={4.0}
      />
    );
  }

  return <>{children}</>;
};

export default PreviewAuthLoader;
